import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const ITextEditorService = ( createDecorator('textEditorService'));
export { ITextEditorService };
